function normalizeText(value) {
  return String(value || "").trim();
}

export function normalizeBillingCycle(value) {
  const normalized = normalizeText(value).toLowerCase();
  if (normalized === "monthly" || normalized === "annual") {
    return normalized;
  }
  return "";
}

export function buildUpgradeStartedPayload({
  fromPlan = "free",
  toPlan = "",
  source = "unknown",
  priceId = "",
  billingCycle = "",
  offerType = "",
} = {}) {
  return {
    from_plan: normalizeText(fromPlan) || "free",
    to_plan: normalizeText(toPlan),
    source: normalizeText(source) || "unknown",
    price_id: normalizeText(priceId),
    billing_cycle: normalizeBillingCycle(billingCycle),
    offer_type: normalizeText(offerType),
  };
}

export function buildPaidConversionPayload({
  fromPlan = "free",
  toPlan = "",
  metadata = {},
} = {}) {
  const normalizedMetadata = metadata && typeof metadata === "object" ? metadata : {};

  return {
    from_plan: normalizeText(fromPlan) || "free",
    to_plan: normalizeText(toPlan),
    price_id: normalizeText(normalizedMetadata.price_id),
    billing_cycle: normalizeBillingCycle(normalizedMetadata.billing_cycle),
    offer_type: normalizeText(normalizedMetadata.offer_type),
  };
}
